import { combineReducers } from "@reduxjs/toolkit";
import siteGalleryReducer from "./siteGallerySlice"
import siteNewsReducer from "./siteNewsSlice"
import siteContactReducer from "./siteContactSlice";
import siteBannerReducer from "./siteBannerSlice"


const siteReducers = combineReducers({
    siteNews: siteNewsReducer,
    siteGallery: siteGalleryReducer,
    siteContacts: siteContactReducer,
    siteBanner: siteBannerReducer
})

export default siteReducers;